import {useNumericFormatSettings} from '_contexts/MySettingsProvider';
import Decimal from 'decimal.js-light';

/**
 * MySettings設定を適用したパース関数を取得するフック
 */
export const useParseWithSettings = () => {
  const settings = useNumericFormatSettings();

  return {
    /**
     * 数値項目 パース用
     * MySettings設定を適用した数値パース（精度・丸めモード適用）
     * @param value パースする値
     * @returns パースされた数値
     */
    parseNumber: (value: number) => {
      if (value == null || !isFinite(value)) {
        return 0;
      }

      try {
        const decimalValue = new Decimal(value);
        const rounded = decimalValue.toDecimalPlaces(
          settings.defaultPrecision,
          settings.defaultRoundingMode
        );
        return rounded.toNumber();
      } catch (error) {
        console.warn('parseNumber: Invalid value', value, error);
        return 0;
      }
    },

    /**
     * パーセント項目 パース用
     * MySettings設定を適用したパーセントパース（精度・丸めモード適用）
     * @param value パースする値
     * @returns パースされたパーセント値
     */
    parsePercent: (value: number) => {
      if (value == null || !isFinite(value)) {
        return 0;
      }

      try {
        const decimalValue = new Decimal(value);
        const rounded = decimalValue.toDecimalPlaces(
          settings.percentPrecision,
          settings.percentRoundingMode
        );
        return rounded.toNumber();
      } catch (error) {
        console.warn('parsePercent: Invalid value', value, error);
        return 0;
      }
    },

    /**
     * サイズ項目 パース用
     * MySettings設定を適用したサイズパース（精度・丸めモード適用）
     * @param value パースする値
     * @returns パースされたサイズ値
     */
    parseSize: (value: number) => {
      if (value == null || !isFinite(value)) {
        return 0;
      }

      try {
        const decimalValue = new Decimal(value);
        const rounded = decimalValue.toDecimalPlaces(
          settings.sizePrecision,
          settings.sizeRoundingMode
        );
        return rounded.toNumber();
      } catch (error) {
        console.warn('parseSize: Invalid value', value, error);
        return 0;
      }
    }
  };
};
